import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class CompanyProfileService {
  index() {
    return axios.get(API_URL + "companies-hirings", { headers: authHeader() });
  }

  // fetch a single profile by id
  show(id) {
    return axios.get(API_URL + `companies-hirings/${id}`, {
      headers: authHeader(),
    });
  }

  // create a new company profile
  // store(resource) {
  //   return axios.post(API_URL + "companies-hirings", resource, {
  //     headers: authHeader(),
  //   });
  // }

  store(resource) {
    return axios.post(API_URL + "companies-hirings", resource, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // update an existing profile
  // update(resource) {
  //   return axios.put(API_URL + `companies-hirings/${resource.id}`, resource, {
  //     headers: authHeader(),
  //   });
  // }

  // services/companyProfile.service.js
  // update(data) {
  //   const id = data.get("id");
  //   return axios.put(`${API_URL}companies-hirings/${id}`, data, {
  //     headers: {
  //       ...authHeader(),
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // }

  update(data) {
    const id = data.get("id");
    data.set("_method", "PUT"); // Add this line to spoof PUT
    return axios.post(`${API_URL}companies-hirings/${id}`, data, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new CompanyProfileService();
